import PropTypes from 'prop-types'

import Placeholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Placeholder'
import { CLOUD_INSET, CLOUD_RADIUS } from '@aytm/app/stats/page/question-views/components/word-cloud/constants/config'

// styles
import style from '@aytm/app/stats/page/question-views/components/charts/placeholders/styles/WordCloud.module.scss'

const WordCloud = ({ children, height, standInHeight, isLoading, onLoad }) => {
  // the stand-in stands where the cloud will: same margin off the card, same corner, so the block
  // does not change shape the moment the real one arrives
  const renderStandIn = ref => (
    <div
      ref={ref}
      className={style.placeholder}
      // a caller whose cloud is drawn at a fixed height of its own asks for it; every other stand-in
      // keeps the stylesheet's height
      style={{
        '--wc-inset': `${CLOUD_INSET}px`,
        '--wc-radius': `${CLOUD_RADIUS}px`,
        ...(null != standInHeight ? { height: `${standInHeight}px` } : {})
      }}
    >
      <span className={style.loader} />
    </div>
  )

  return (
    <Placeholder
      height={height}
      // a cloud is content an export waits on, as a chart is
      required
      loadAll={window.$FullWordCloudsLoading || false}
      isLoading={isLoading}
      onLoad={onLoad}
      renderStandIn={renderStandIn}
    >
      {children}
    </Placeholder>
  )
}

WordCloud.displayName = 'WordCloud'

WordCloud.propTypes = {
  children: PropTypes.any,
  height: PropTypes.number,
  standInHeight: PropTypes.number,
  isLoading: PropTypes.bool,
  isInverse: PropTypes.bool,
  isAnimated: PropTypes.bool,
  onLoad: PropTypes.func
}

export default WordCloud
